import React from "react";
import { string } from "prop-types";

const VideoBlackIcon = ({ largeIcon }) =>
  largeIcon ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90">
      <g id="Play_icon_72px" data-name="Play icon 72px" transform="translate(9 6)">
        <g transform="translate(-9 -6)">
          <circle
            id="Ellipse_68-2"
            cx="36"
            cy="36"
            r="36"
            fill="#121212"
            data-name="Ellipse 68"
            transform="translate(9 6)"
          />
        </g>
        <path
          id="Path_204"
          fill="#e2e2e2"
          d="M22.736 11.532L3.879.384A2.557 2.557 0 0 0 0 2.6v22.288A2.569 2.569 0 0 0 3.879 27.1l18.857-11.142a2.569 2.569 0 0 0 0-4.425z"
          data-name="Path 204"
          transform="translate(26 21.968)"
        />
      </g>
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60">
      <defs>
        <filter id="a" width="60" height="60" x="0" y="0" filterUnits="userSpaceOnUse">
          <feOffset dy="3" />
          <feGaussianBlur result="blur" stdDeviation="3" />
          <feFlood floodOpacity=".322" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Play icon 42px_dark">
        <g filter="url(#a)">
          <circle
            cx="21"
            cy="21"
            r="21"
            data-name="Ellipse 68"
            transform="translate(9 6)"
            fill="#121212"
            opacity=".8"
          />
        </g>
        <path
          d="M37.263 25.709l-11-6.5A1.492 1.492 0 0024 20.496v13a1.5 1.5 0 002.263 1.291l11-6.5a1.5 1.5 0 000-2.581z"
          data-name="Path 204"
          fill="#e2e2e2"
        />
      </g>
    </svg>
  );

VideoBlackIcon.propTypes = {
  largeIcon: string,
};

export default VideoBlackIcon;
